// src/App.js
import React from 'react';
import ManukapiDocs from './ManukapiDocs';
import './styles/globals.css';

const App = () => {
  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <ManukapiDocs />
    </div>
  );
};

export default App;